import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal, TableColumnsType, Table } from 'antd';
import { IGeneralMessageCustomer } from '../../../../models/pushMessage.model';
import FileUpload from '../../../FileUpload';
import Button from '../../../Button';
// @ts-ignore
import { ExcelRenderer } from 'react-excel-renderer';
import { phoneValidation } from '../../../../lib/util';
import styled from 'styled-components';

const ScrollBox = styled.div`
  height: 500px;
  overflow-y: auto;
`;
interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;

  setCustomers: (value: IGeneralMessageCustomer[]) => void;
}

const UploadGeneralExcelModal: FC<IProps> = ({
  visible,
  setVisible,
  setCustomers,
}) => {
  const { t } = useTranslation();
  const [file, setFile] = useState<any>(null);
  const [data, setData] = useState<IGeneralMessageCustomer[]>([]);

  const onHandleExcel = (fileObj: any) => {
    setFile(fileObj);
    ExcelRenderer(fileObj, (error: any, response: any) => {
      if (error) return console.log(error);

      const _data: IGeneralMessageCustomer[] = [];

      const rows = (response.rows as string[][]).slice(1, response.rows.length);
      for (const row of rows) {
        if (row[0]) {
          if (phoneValidation(row[0])) {
            if (!_data.map(({ phone }) => phone).includes(row[0])) {
              _data.push({ phone: row[0], name: row[1] });
            }
          }
        } else {
          break;
        }
      }
      setData(_data);
    });
  };

  const columns: TableColumnsType<IGeneralMessageCustomer> = [
    {
      title: 'No',
      align: 'center',
      render: (value, record, index) => index + 1,
    },
    {
      title: t('student.student.placeholder1'),
      dataIndex: 'phone',
      key: 'phone',
      align: 'center',
    },
  ];

  return (
    <>
      <Modal
        title={t('sms.send.title2')}
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={() => {
                setCustomers(data);
                setVisible(false);
              }}
              disabled={data.length === 0}
            >
              {t('student.student.button4')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => {
                setVisible(false);
              }}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div className="flex flex-justify-center">
          <FileUpload file={file} setFile={onHandleExcel} accept=".xlsx" />
          <div
            style={{
              position: 'relative',
              top: '1px',
            }}
          >
            <a
              className="download-link"
              href="/upload_members.xlsx"
              download="upload_members.xlsx"
            >
              <div className='comm-btn__area ml-2'>
                <Button
                  className="btn-basic green"
                  onClick={() => {}}
                  text={t('sms.send.button5')}
                />
              </div>
            </a>
          </div>
        </div>
        {data.length >= 1 && (
          <ScrollBox>
            <div className="inside-table-wrapper mt-3">
              <Table columns={columns} dataSource={data} pagination={false} />
            </div>
          </ScrollBox>
        )}
      </Modal>
    </>
  );
};

export default UploadGeneralExcelModal;
